import Vue from 'vue';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

Vue.component('vue-cropper', VueCropper);
